import React from "react";
import { AppBar } from "discover.medical.react-component-library";
import "./index.css";

export const Header = ({ logo }) => {
  return (
    <AppBar.Container className="AppBarContainer">
      <div className={"FixedWidthHeader"}>
        {logo && (
          <img className={"Header__logo"} src={logo.src} alt={logo.alt} />
        )}
      </div>
    </AppBar.Container>
  );
};

export default Header;
